console.log('Run');
document.addEventListener('algolia.hooks.initialize', function() {
  console.log('Ready',algoliaShopify);
  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    console.log('defaultWidgets',defaultWidgets);
    const hitsWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.hits'
    );
    
    // Find and return the default pagination widget
    const defaultPaginationWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.pagination'
    );

    return [hitsWidget, defaultPaginationWidget];
  });
});

document.addEventListener ('algolia.hooks.initialize', function() {
  const { infiniteHits } = window.instantsearch.widgets;
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const infiniteHitsWidget = infiniteHits({
      container:'.ais-hits-container',
      templates: {
        item(hit, { html, components }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(
            hit,
            html,
            components,
            window.algoliaShopify
          );
        },
        empty(results, { html }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
            html,
            window.algoliaShopify
          );
        },
      },
      transformItems: items => {
        const transformedItems = items.map(item => ({
          ...item,
          _distinct: window.algoliaShopify.instantsearch.distinct,
          can_order:
            item.inventory_policy === 'continue' || item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item._position,
          index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
        }));
        return transformedItems;
      },
    });
    return [infiniteHitsWidget];
  });
});
                           